export const GET_DOCUMENT_SHORTS = 'GET_DOCUMENT_SHORTS';
export const GET_DYNAMIC_DOCUMENT_ITEMS = 'GET_DYNAMIC_DOCUMENT_ITEMS';
export const SET_REGISTER = 'SET_REGISTER';
export const GET_ERROR_DOCUMENT_IDS = 'GET_ERROR_DOCUMENT_IDS';
